import { defineStore } from "pinia";
import { ref } from "vue";

export const useMenuStore = defineStore("menu", () => {
    const topmenuActive = ref(0);

    const isShowSideMenu = ref(true);

    function reset() {
        count.value = 0;
    }

    function setMenu(menuId) {
        topmenuActive.value = menuId;
    }

    function setIsShowSideMenu(value) {
        isShowSideMenu.value = value
    }

    return {
        topmenuActive,
        isShowSideMenu,
        reset,
        setMenu,
        setIsShowSideMenu
    };
});
